<template>
  <div>
    <GlobalHead />
    <div style="width: 100%; padding-top: 25px">
      <div class="marginAuto">
        <div>
          <div>
            <span class="title">当前位置：</span>
            <span class="title3">一件事进度查询</span>
          </div>
          <div class="middle">
            <div class="allWrapper">
              <div class="title1">
                <span>一件事进度查询</span>
              </div>
              <div class="title2">
                <!-- <span>
                  您可在此凭借办件编号查询办件进度，也可以
                  <span class="blue" @click="toLogin">登录</span>
                  后进入个人中心页找到办事记录，查看进度更方便。
                </span> -->
              </div>
              <div class="item1">
                <a-form :form="form" :layout="formLayout">
                  <a-form-item
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    label="办件编号"
                  >
                    <a-input
                      class="input1"
                      placeholder="请输入办件编号"
                      v-decorator="[
                        'applyNumber',
                        { rules: [{ required: true, message: '办件编号不能为空' }] }
                      ]"
                    />
                  </a-form-item>
                  <!-- <a-form-item
                    :label-col="formItemLayout.labelColy"
                    :wrapper-col="formItemLayout.wrapperColy"
                    label="手机号码"
                  >
                    <div style="display: flex">
                      <a-input
                        class="input2"
                        v-decorator="[
                          'receivePhone',
                          { rules: [{ required: true, message: '手机号码不能为空' }] }
                        ]"
                        placeholder="请输入申请人手机号码"
                      ></a-input>
                      <a-button
                        type="solid"
                        :class="bianliang ? 'huise' : 'yz'"
                        id="new_yan"
                        :disabled="disabled"
                        @click="button"
                      >
                        <span v-show="show" class="word1">获取验证码</span>
                        <span v-show="!show">{{ count }}秒后获取</span>
                      </a-button>
                    </div>
                    <span class="sendSuccess" v-show="sendSuccess">{{ sendReturn }}</span>
                  </a-form-item>

                  <a-form-item
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    label="验证码"
                  >
                    <a-input
                      class="input1"
                      placeholder="请输入验证码"
                      v-decorator="[
                        'yz',
                        { rules: [{ required: true, message: '验证码不能为空' }] }
                      ]"
                    />
                  </a-form-item> -->
                </a-form>
              </div>
              <div style="margin-left: 115px">
                <a-button class="btnStyle1" type="primary" @click="submit">
                  <span class="word2">立即查询</span>
                </a-button>
              </div>
            </div>
            <div class="message">
              <span class="word3">
                若查询无果，您可以:
              </span>
              <br />
              <span class="word4">
                1.拨打96359政务热线电话,寻求在线客服的帮助;<br>
                2.前往政务服务大厅。使用您的身份证在大厅服务及上进行查询;<br>
                3.登录政府服务网账号,进入个人中心进行查询;
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <GlobalFood /> -->
  </div>
</template>

<script>
import GlobalHead from '@/views/layout/globalHead'
// import GlobalFood from '@/views/layout/globalFood'
import { jiopWebAPI } from '@/api/jiopweb/gzy-jiopweb'
import { sm2 } from 'sm-crypto'
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 15 },
  labelColy: { span: 4 },
  wrapperColy: { span: 15 }
}
export default {
  name: 'QueryHandling',
  components: {
    GlobalHead
    // GlobalFood
  },
  data () {
    return {
      show: true,
      formItemLayout,
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      fhyzm: '',
      bianliang: 0,
      count: 60,
      disabled: false,
      timer: null,
      sendSuccess: false,
      sendFail: false,
      submitSuccess: false,
      yzmfs: null,
      receivePhone: null,
      applyNumber: null,
      applyNumberjm: null,
      sendReturn: null,
      yzm: null,
      sendMesg: null,
      sendInfoStr: null
    }
  },
  methods: {
    toLogin () {
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          this.$message.warning('您已登录')
        } else {
          this.toLoginPage()
        }
      } else {
        this.toLoginPage()
      }
    },
    toLoginPage () {
      const params = this.$route.query || {}
      params.jiopWorkUrl = 'jiopweb/' + this.$route.name
      jiopWebAPI.getLoginUrl({ params: JSON.stringify(params) }).then(res => {
        if (res.success) {
          if (res.data.url) {
            window.location.href = res.data.url
          }
        }
      })
    },
    encrypt: function (str, publicKey) {
      return '04' + sm2.doEncrypt(str, publicKey, 1)
    },
    rand: function (min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    button () {
      this.form.validateFields(['receivePhone', 'applyNumber'], err => {
        if (!err) {
          this.count = 60
          this.show = false
          this.disabled = true
          this.bianliang = 1
          this.receivePhone = this.form.getFieldValue('receivePhone')
          this.applyNumber = this.form.getFieldValue('applyNumber')
          // this.sendMesg = 'receivePhone:' + this.mobile + ',' + 'applyNumber:' + this.applyNumber
          const params = {}
          params.receivePhone = this.receivePhone
          params.applyNumber = this.applyNumber
          this.sendMesg = JSON.stringify(params)
          this.sendMesg = this.encrypt(
            this.sendMesg,
            '0447c33b1ff9cbb2f15aae1b753c8a306e605a6b87b9441402f5e757dcbcfe4ab28bc340f8e6508918ca59799940d8b5f9fd556211f5803d2ae4aec580de48268d'
          )
          jiopWebAPI
            .getVerifyCode({
              infoStr: this.sendMesg
            })
            .then(res => {
              if (res.success) {
                this.sendReturn = '发送成功'
                // this.sendSuccess = true
                alert(res.message)
              } else {
                // this.sendFail = true
                this.sendReturn = res.message
                // this.sendSuccess = true
                alert(res.message)
              }
            })
          // 将鼠标设置为不可点击状态
          // document.getElementById('new_yan').style.cursor = 'not-allowed'
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
              if (this.count === 57) {
                this.sendFail = false
                this.sendSuccess = false
              }
            } else {
              this.show = true
              this.bianliang = 0
              clearInterval(this.timer)
              this.timer = null
              this.disabled = false
            }
          }, 1000)
        } else {
        }
      })
    },
    submit () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        if (!err) {
          this.applyNumber = this.form.getFieldValue('applyNumber')
          const params = {}
          params.applyNumber = this.applyNumber
          params.code = this.form.getFieldValue('yz')
          this.sendInfoStr = JSON.stringify(params)
          this.sendInfoStr = this.encrypt(
            this.sendInfoStr,
            '0447c33b1ff9cbb2f15aae1b753c8a306e605a6b87b9441402f5e757dcbcfe4ab28bc340f8e6508918ca59799940d8b5f9fd556211f5803d2ae4aec580de48268d'
          )
          // jiopWebAPI.verifyCode({ infoStr: this.sendInfoStr }).then(res => {
          // if (res.success) {
          const url = this.$router.resolve({
            path: '/handlingInfo',
            query: {
              applyNumber: this.applyNumber,
              // applyNumber: 'JIOP2024072400006',
              materialState: 'nosupplement',
              matterId: 'bY7aepBRnqlvOUSIXvTcQ',
              handleType: 'onething'
            }
          })
          window.open(url.href, '_blank')
          // applyNumber=JIOP2024072400006&materialState=nosupplement&matterId=bY7aepBRnqlvOUSIXvTcQ&handleType=onething
          // } else {
          //   alert(res.message)
          // }
          // })
        }
      })
    },
    watch () {
      this.timer(val => {
        if (val == null) {
          //  监听timer变化，移除不可点击样式
          this.yz.removeClass('huise')
          this.bianliang = this.yz
          this.disabled = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.marginAuto {
  width: 1200px;
  margin: auto;
}
.allWrapper {
  // display: inline;
  // background: #fff;
  width: 700px;
  // float: left;
}
.title {
  width: 70px;
height: 20px;

font-size: 14px;
color: #999999;
letter-spacing: 0;
font-weight: 400;
}
.title1 {
width: 160px;
height: 40px;

font-size: 22px;
color: #333333;
letter-spacing: 0;
line-height: 40px;
font-weight: 500;
margin-top: 30px;
}
.title2 {
  width: 700px;
height: 20px;

font-size: 14px;
color: #999999;
letter-spacing: 0;
line-height: 20px;
font-weight: 400;
margin-top: 4px;
}
.title3{
  width: 84px;
height: 20px;

font-size: 14px;
color: #333333;
letter-spacing: 0;
line-height: 20px;
font-weight: 400;
}
.input1{
  width: 435px;
height: 40px;
border: 1px solid rgba(221,221,221,1);
border-radius: 2px;
}
.input2{
  width: 317px;
height: 40px;
border: 1px solid rgba(221,221,221,1);
border-radius: 2px;
}
.word1{
  width: 70px;
height: 22px;

font-size: 14px;
color: #1677FF;
line-height: 22px;
font-weight: 400;
}
.word2{
  width: 90px;
height: 21px;
font-size: 16px;
color: #FFFFFF;
text-align: center;
font-weight: 400;
}
.word3{
display: inline-block;
margin-top: 30px;
margin-left: 30px;
width: 160px;
height: 22px;

font-size: 16px;
color: #333333;
letter-spacing: 0;
font-weight: 500;
}
.word4{
  display: inline-block;
  margin-left: 30px;
  margin-top: 12px;
width: 400px;
height: 112px;

font-size: 14px;
color: #666666;
letter-spacing: 0;
line-height: 28px;
font-weight: 400;
}
.blue {
  font-size: 14px;
  font-weight: 550;
  color: #108ee9;
  cursor: pointer;
}
.item1 {
  margin-top: 30px;
}
.btnStyle1 {
  width: 150px;
height: 50px;
background: #1677FF;
border-radius: 2px;
}
.yz {
 width: 106px;
height: 40px;
background: #EDF5FF;
border: 1px solid rgba(151,195,255,1);
border-radius: 2px;
margin-left: 12px;
}
.huise {
  width: 106px;
height: 40px;
  font-size: 14px;
  font-weight: 550;
  background-color: #dcdcdc;
  color: black;
  margin-left: 10px;
}
.sendSuccess,.sendFail{
  font-size: 19px;
  font-weight: 550;
  color: #108ee9;
}
.message {
width: 460px;
height: 342px;
border: 1px dashed rgba(221,221,221,1);
}
.item2 {
  float: left;
}
/deep/ .ant-form-item-label {
  text-align: left;
}
.middle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 45px;
}
.formSubmit {
  font-size: 19px;
  font-weight: 550;
  color: #108ee9;
}
.showtip {
  font-size: 19px;
  font-weight: 550;
  color: #108ee9;
  display: block;
  clear: both;
  min-height: 22px;
  margin-top: -2px;
  line-height: 1.5;
  -webkit-transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.closetip {
  display: none;
}
</style>
